import { z } from "zod";

export const workspaceContextSchema = z.object({
  workspace_id: z.coerce.string(),
  workspace_name: z.string().nullable(),
  effective_team_id: z.number().nullable(),
  plugin_hash: z.string().nullable(),
  skills: z.array(z.object({ id: z.string(), name: z.string() })),
  skills_installed: z.array(
    z.object({ id: z.string(), skill_id: z.string(), bundle_token: z.string() })
  ),
  knowledge_ids: z.array(z.number()),
  memory_enabled: z.boolean(),
  rules_count: z.number(),
  // Keep unknown reasons for forward compatibility; never display raw payloads.
  reason: z.string().nullable(),
});
export const workspaceEventSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("workspace_context"), content: workspaceContextSchema }),
  z.object({
    type: z.literal("workspace_status"),
    content: z.object({
      workspace_id: z.coerce.string(),
      reason: z.string(),
      skill_id: z.string().optional(),
    }),
  }),
]);
export type WorkspaceEvent = z.infer<typeof workspaceEventSchema>;
export type WorkspaceContext = z.infer<typeof workspaceContextSchema>;

const WORKSPACE_EVENT_TYPES: unknown[] = ["workspace_context", "workspace_status"];

/** Move workspace metadata to a non-rendered channel; drop a malformed one rather than
 * failing the whole turn. */
export const normalizeWorkspaceEvent = (value: unknown): unknown => {
  const type = (value as { type?: unknown } | null)?.type;
  if (!WORKSPACE_EVENT_TYPES.includes(type)) return value;
  const parsed = workspaceEventSchema.safeParse(value);
  return parsed.success ? { type: "custom", workspaceEvent: parsed.data } : { type: "custom" };
};
